import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BASE_URL} from '../constants';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }

  logout() {
    localStorage.removeItem('currentUser');
  }

  loginUser(userData): Observable<any> {
    return this.http.post(BASE_URL + '/user/login/', userData).pipe(
      map((user$: any) => {
        // login successful if there's a jwt token in the response
        if (user$) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          if (user$.token) {
            localStorage.setItem('currentUser', JSON.stringify(user$));
          }
        }
        return user$;
      })
    );
  }

  loginUserWithToken(uid, token): Observable<any> {
    return this.http.post(BASE_URL + '/user/login_by_token/', {uid, token}).pipe(
      map((user: any) => {
        // login successful if there's a jwt token in the response
        if (user) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          if (user.token) {
            localStorage.setItem('currentUser', JSON.stringify(user));
          }
        }
        return user;
      })
    );
  }

  checkUserStatus(): Observable<any> {
    return this.http.get(BASE_URL + '/user/status/').pipe(map(res => res));
  }

  resetPassword(email): Observable<any> {
    const params = {email: email};
    return this.http.post(BASE_URL + '/user/reset-password/', params);
  }

  resetPasswordConfirmStatus(params): Observable<any> {
    return this.http.post(BASE_URL + '/user/reset-password/status/', params);
  }

  resetPasswordConfirm(params): Observable<any> {
    return this.http.post(BASE_URL + '/user/reset-password/confirm/', params);
  }

  changePassword(params): Observable<any> {
    return this.http.post(BASE_URL + '/user/reset-password/change/', params);
  }
}
